var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mini-program-entry',{key:_vm.$route.fullPath,attrs:{"code":_vm.code,"business-code":_vm.businessCode,"standalone":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }